const rawApiBase = process.env.REACT_APP_BACKEND_URL;

// Default to same-origin in environments where no explicit API base is provided.
export const API_BASE_URL = rawApiBase && rawApiBase.trim()
  ? rawApiBase.replace(/\/+$/, '')
  : '';

// Backward-compatible alias used in existing modules.
export const API_BASE = API_BASE_URL;

